import { ScrollLink } from '../../../components/ScrollLink'
import { useConfiguratorStore } from '../../../contexts/ConfiguratorStore'
import styles from './rating.module.scss'

import React from 'react'

import Rating from 'Clutch/Atoms/Rating'
import TextLink from 'Clutch/Atoms/TextLink'
import Typography from 'Clutch/Atoms/Typography'

const ConfiguratorRatingAndQuestionsOverview = () => {
  const numberOfQuestions = useConfiguratorStore((x) => x.numberOfQuestions)
  const reviewCount = useConfiguratorStore((x) => x.reviewCount)
  const ratingValue = useConfiguratorStore((x) => x.rating)

  return (
    <div>
      <Rating ratingValue={ratingValue} />
      <span className={styles.rating_spacer}></span>

      {reviewCount ? (
        <ScrollLink
          id="pdp_ratings"
          accordionName="RatingsAndReviews"
          size={0.75}
          tone={'subtle'}
          inline
          underline
          shouldOpenAccordion={true}
        >
          {reviewCount + ` ${reviewCount === 1 ? 'Review' : 'Reviews'}`}
        </ScrollLink>
      ) : (
        <TextLink size={0.75} tone={'subtle'} inline underline>
          Write a Review
        </TextLink>
      )}

      <Typography size={0.75} tone={'subtle'} inline>
        {' | '}
      </Typography>

      {numberOfQuestions ? (
        <ScrollLink
          id="pdp_qna"
          accordionName="QuestionsAndAnswers"
          size={0.75}
          tone={'subtle'}
          inline
          underline
          shouldOpenAccordion={true}
        >
          {numberOfQuestions + ` ${numberOfQuestions === 1 ? 'Question' : 'Questions'}`}
        </ScrollLink>
      ) : (
        <ScrollLink
          id="pdp_qna"
          accordionName="QuestionsAndAnswers"
          size={0.75}
          tone={'subtle'}
          inline
          underline
          shouldOpenAccordion={true}
        >
          Ask a Question
        </ScrollLink>
      )}
    </div>
  )
}

export default ConfiguratorRatingAndQuestionsOverview
